export default {"src":"/_next/static/media/tos.90cc9bc2.svg","height":128,"width":128};